var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{style:(_vm.compileElementStyles('image', ['title', 'text_alignment', 'border', 'margin', 'padding', 'size'])),attrs:{"src":"/images/product-placeholder.png"}})])}
var staticRenderFns = []

export { render, staticRenderFns }